import { render, staticRenderFns } from "./BenefitType.vue?vue&type=template&id=b108b688&"
import script from "./BenefitType.vue?vue&type=script&lang=js&"
export * from "./BenefitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports